module.exports = __webpack_public_path__ + "img/003.99547de5.png";